var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-result__set" },
    [
      _c("h2", { staticClass: "results__heading" }, [
        _vm._v(_vm._s(_vm.resultSet.sectionHeadline) + " "),
        _c("span", { staticClass: "resultCount" }, [
          _vm._v("(" + _vm._s(_vm.resultSet.resultCount) + ")"),
        ]),
      ]),
      _vm._v(" "),
      _vm.resultSet.type === _vm.resultTypes.text
        ? [
            _vm._l(_vm.resultSet.results, function (result, index) {
              return [
                _vm.resultSetSetting === _vm.resultKinds.all
                  ? [
                      index < 4
                        ? [
                            _c("search-result-text", {
                              key: result.id,
                              attrs: { result: result },
                            }),
                          ]
                        : _vm._e(),
                    ]
                  : [
                      _c("search-result-text", {
                        key: result.id,
                        attrs: { result: result },
                      }),
                    ],
              ]
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.resultSet.type === _vm.resultTypes.tile
        ? [
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm._l(_vm.resultSet.results, function (result, index) {
                  return [
                    _vm.resultSetSetting === _vm.resultKinds.all
                      ? [
                          index < 3
                            ? [
                                _c("search-result-tile", {
                                  key: result.id,
                                  staticClass: "col-6 col-md-4 col-lg-3",
                                  attrs: { result: result },
                                }),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          index === 3
                            ? [
                                _c("search-result-tile", {
                                  key: result.id,
                                  staticClass:
                                    "col-6 col-md-4 col-lg-3 hide-tablet",
                                  attrs: { result: result },
                                }),
                              ]
                            : _vm._e(),
                        ]
                      : [
                          _c("search-result-tile", {
                            key: result.id,
                            staticClass: "col-6 col-md-4 col-lg-3",
                            attrs: { result: result },
                            on: { "image-loaded": _vm.onImageLoaded },
                          }),
                        ],
                  ]
                }),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.resultSet.type === _vm.resultTypes.downloads
        ? [
            _c("search-result-downloads", {
              attrs: { downloads: _vm.resultSet.results },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.resultSet.resultCount > _vm.resultSet.results.length
        ? [
            _c("div", { staticClass: "button-wrapper v-center right" }, [
              _c(
                "button",
                {
                  staticClass: "button button--secondary",
                  class: { "button--loading": _vm.isLoadingMore },
                  on: { click: _vm.loadMore },
                },
                [_vm._v(_vm._s(_vm.localization.buttons.more))]
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }